<div class="modal-content mat-confirm-modal-content">
    <div class="modal-header my-3 pl-5 text-center">
        <h4 *ngIf="confirmData.title">{{ confirmData.title || 'Confirmación'}}</h4>
    </div>
    <div class="modal-body px-5">
        <p>{{ confirmData.message || ''}}</p>
    </div>
    <div class="modal-footer d-flex justify-content-center my-3 bg-white">
        <p class="custom-timer" *ngIf="counter$ | async as counter">
            {{(counter < 10 && counter !== 0? '0': '') + counter}}s
        </p>
        <button type="button" class="custom-button-error-container mx-2" (click)="close()" mat-flat-button *ngIf="confirmData.hideCancelmButtom !== true">
            {{confirmData.textBoton && confirmData.textBoton.length > 0?  confirmData.textBoton[1]: 'Cancelar'}}
        </button>
        <button type="button" class="custom-button-primary-container mx-2" (click)="confirm()" mat-flat-button *ngIf="confirmData.hideConfirmButtom !== true">
            {{confirmData.textBoton && confirmData.textBoton.length > 0? confirmData.textBoton[0]: 'Continuar'}}
        </button>
    </div>
</div>